import type { RuleFiring, RuleSeverity, RuleFactor } from "./types";

/** Local-midnight ISO yyyy-mm-dd from a Date. */
export function toIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Days difference: a - b in calendar days (date-only, ignoring tz). */
export function daysBetween(aIso: string, bIso: string): number {
  const a = new Date(`${aIso}T00:00:00`).getTime();
  const b = new Date(`${bIso}T00:00:00`).getTime();
  return Math.round((a - b) / 86_400_000);
}

/** Mean of an array, ignoring nulls. Returns null if all null. */
export function mean(values: (number | null | undefined)[]): number | null {
  const real = values.filter((v): v is number => typeof v === "number" && !Number.isNaN(v));
  if (real.length === 0) return null;
  return real.reduce((s, v) => s + v, 0) / real.length;
}

export function makeFiring(args: {
  rule_id: string;
  now: Date;
  tz: string;
  severity: RuleSeverity;
  message: string;
  evidence_refs?: string[];
  factors?: RuleFactor[];
  target_surface?: string;
  target_action?: RuleFiring["target_action"];
}): RuleFiring {
  return {
    rule_id: args.rule_id,
    ts: args.now.toISOString(),
    tz: args.tz,
    severity: args.severity,
    message: args.message,
    evidence_refs: args.evidence_refs ?? [],
    factors: args.factors ?? [],
    target_surface: args.target_surface,
    target_action: args.target_action,
  };
}
